import { isNil } from 'lodash';

export default function buildServerResponseGate({ playbookOutput, canDeliverEvent, deliverBuildError }) {
  const disabled = isNil(playbookOutput.outputEvent) || !canDeliverEvent || Boolean(deliverBuildError);

  let tooltip;
  if (isNil(playbookOutput.outputEvent)) {
    tooltip = 'Playbook Output is required';
  } else if (!canDeliverEvent) {
    tooltip = 'You do not have permission to deliver events';
  } else if (deliverBuildError) {
    tooltip = 'This integration is not attached to the selected pipeline; required connection variables are missing';
  }

  return { disabled, tooltip };
}
